import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const SecreteEvent = ({ handleClose, open }) => {
  // const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);

  return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="popup">
          <Typography
            id="modal-modal-title"
            className="infoPopup_heading"
            variant="h6"
            component="h2"
            style={{ fontSize: "24px" }}
          >
            Secret Events
          </Typography>
          <Typography
            id="modal-modal-title-desc"
            variant="h6"
            component="h2"
            style={{ fontSize: "16px", fontWeight: "400" }}
          >
            In secret mode, nobody can find your event on the platform unless
            you invite them to it.
          </Typography>
        </Box>
      </Modal>
  );
};

export default SecreteEvent;
